:host {
  display: block;
  font-family: var(--ls-font-family);
}

.failed-to-load-error {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
  width: 500px;
  font-style: italic;
  color: #dc2626;
  background-color: #fef2f2;
  border-radius: 2px;
}

.error-message {
  font-size: var(--ls-text-xl);
  line-height: var(--ls-line-xl);
  padding: 0.5rem 0;
  position: absolute;
  top: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-style: italic;
  color: #dc2626;
  background-color: #fef2f2;
  border-radius: 2px;
  opacity: 1;
  animation: append-animate 0.3s ease-in;
}

@keyframes append-animate {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.blur {
  filter: blur(10px);
  -webkit-filter: blur(10px);
}

.canvas {
  position: relative;
  width: 500px;
  height: 500px;
}

.current-floor {
  top: 0;
}

.last-passed-floor {
  bottom: 0;
}

.last-update {
  position: absolute;
  bottom: 0.5rem;
  right: 0;
  font-size: var(--ls-text-xs);
  line-height: var(--ls-line-xs);
  color: var(--ls-gray-600);
  background-color: var(--ls-gray-100);
  padding: 0.25rem 0.5rem;
  border-radius: 20px;
}
